(() => {
  const enhanceVariantImages = (root = document) => {
    root.querySelectorAll('[data-kp-variant-media]:not([data-kp-ready])').forEach((dataNode) => {
      let payload;
      try {
        payload = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      dataNode.dataset.kpReady = 'true';
      const scope = dataNode.closest('.shopify-section') || document;
      const fieldsets = [...scope.querySelectorAll('.product-form__input')].filter((fieldset) =>
        fieldset.querySelector('input[type="radio"]')
      );

      fieldsets.forEach((fieldset, optionIndex) => {
        const imageByValue = new Map();

        payload.variants.forEach((variant) => {
          const value = variant.options?.[optionIndex];
          if (value && variant.image && !imageByValue.has(value)) {
            imageByValue.set(value, variant.image);
          }
        });

        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          const label = scope.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          const image = imageByValue.get(input.value);
          if (!label || !image || label.classList.contains('kp-variant-image-label')) return;

          const labelText = input.value;
          label.classList.add('kp-variant-image-label');
          label.setAttribute('title', labelText);
          label.replaceChildren();

          const thumbnail = document.createElement('img');
          thumbnail.src = image;
          thumbnail.alt = labelText;
          thumbnail.width = 72;
          thumbnail.height = 72;
          thumbnail.loading = 'lazy';

          const valueText = document.createElement('span');
          valueText.className = 'kp-variant-image-label__text';
          valueText.textContent = labelText;

          label.append(thumbnail, valueText);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceVariantImages());
  } else {
    enhanceVariantImages();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceVariantImages(event.target));
})();
